// import React, { useMemo } from "react";
// import { useSelector } from "react-redux";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import Paper from "@mui/material/Paper";
// import Checkbox from "@mui/material/Checkbox";
// import { Box, Grid, Typography } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import dayjs from "dayjs";
// import Loader from "../Utility/Loader";
// import NotFound from "../Utility/NotFound";

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   "&.MuiTableCell-head": {
//     // backgroundColor: theme.palette.common.black,
//     backgroundColor: "#1976d2",
//     color: theme.palette.common.white,
//     fontSize: 12,
//     fontWeight: 600,
//     padding: "4px",
//     height: "30px",
//     lineHeight: "1",
//     borderRight: "1px solid #ddd",
//   },
//   "&.MuiTableCell-body": {
//     fontSize: 12,
//     color: "black",
//     padding: "2px 4px",
//     lineHeight: "1",
//     borderRight: "1px solid #ddd",
//   },
// }));

// const StyledTableRow = styled(TableRow)(({ bgcolor }) => ({
//   backgroundColor: bgcolor || "inherit",
//   "& td, & th": {
//     backgroundColor: "inherit",
//     textAlign: "center",
//     padding: "2px 4px",
//     height: "30px",
//     borderBottom: "1px solid #ddd",
//   },
// }));

// export default function AttendanceCard() {
//   const { responseBody, loading, msg } = useSelector(
//     (state) => state.attendanceCard
//   );

//   const mappedItems = useMemo(() => {
//     return (
//       <TableContainer
//         component={Paper}
//         sx={{ width: "100%", overflowX: "auto" }}
//       >
//         <Table
//           sx={{ tableLayout: "fixed", width: "100%" }}
//           aria-label="attendance table"
//         >
//           <TableHead>
//             <TableRow>
//               <StyledTableCell
//                 align="center"
//                 rowSpan={2}
//                 sx={{ width: "20%", borderRight: "1px solid #ddd" }}
//               >
//                 Day
//               </StyledTableCell>
//               <StyledTableCell
//                 align="center"
//                 colSpan={3}
//                 sx={{ borderRight: "1px solid #ddd" }}
//               >
//                 Attendance
//               </StyledTableCell>
//               <StyledTableCell align="center" colSpan={2}>
//                 Vehicle
//               </StyledTableCell>
//             </TableRow>
//             <TableRow>
//               <StyledTableCell
//                 align="center"
//                 sx={{ width: "15%", borderRight: "1px solid #ddd" }}
//               >
//                 IN
//               </StyledTableCell>
//               <StyledTableCell
//                 align="center"
//                 sx={{ width: "5%", borderRight: "1px solid #ddd" }}
//               >
//                 C
//               </StyledTableCell>
//               <StyledTableCell
//                 align="center"
//                 sx={{ width: "15%", borderRight: "1px solid #ddd" }}
//               >
//                 OUT
//               </StyledTableCell>
//               <StyledTableCell
//                 align="center"
//                 sx={{ width: "15%", borderRight: "1px solid #ddd" }}
//               >
//                 IN
//               </StyledTableCell>
//               <StyledTableCell align="center" sx={{ width: "15%" }}>
//                 OUT
//               </StyledTableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {responseBody.map((row, index) => (
//               <StyledTableRow key={index} bgcolor={row.BackgroundColor}>
//                 <StyledTableCell
//                   component="th"
//                   scope="row"
//                   align="center"
//                   sx={{ borderRight: "1px solid #ddd" }}
//                 >
//                   <Box
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       flexDirection: "column",
//                       justifyContent: "center",
//                       backgroundColor: "#B5E8FF",
//                       padding: "4px",
//                       borderRadius: 2,
//                       width: "100%",
//                       height: "30px",
//                     }}
//                   >
//                     <Typography
//                       fontSize={12}
//                       fontWeight={600}
//                       sx={{ color: "black", lineHeight: "1" }}
//                     >
//                       {new Date(row.Date).getDate()}
//                     </Typography>
//                     <Typography
//                       fontSize={9}
//                       fontWeight={600}
//                       sx={{ color: "black", lineHeight: "1" }}
//                     >
//                       {row.Day.toString().substring(0, 3)}
//                     </Typography>
//                   </Box>
//                 </StyledTableCell>

//                 {row.LeaveType !== "" ? (
//                   <StyledTableCell
//                     align="center"
//                     colSpan={5}
//                     sx={{
//                       fontWeight: "bold",
//                       fontSize: "14px",
//                       color: "black",
//                     }}
//                   >
//                     {row.LeaveReason}
//                   </StyledTableCell>
//                 ) : (
//                   <>
//                     <StyledTableCell
//                       align="center"
//                       sx={{ borderRight: "1px solid #ddd" }}
//                     >
//                       {row.InTime
//                         ? dayjs(row.InTime, "hh:mm A").format("HH:mm")
//                         : ""}
//                     </StyledTableCell>
//                     <StyledTableCell
//                       align="center"
//                       sx={{ borderRight: "1px solid #ddd" }}
//                     >
//                       {row.ContinuedStatus === "Y" ? (
//                         <Checkbox checked disabled />
//                       ) : (
//                         ""
//                       )}
//                     </StyledTableCell>
//                     <StyledTableCell
//                       align="center"
//                       sx={{ borderRight: "1px solid #ddd" }}
//                     >
//                       {row.OutTime
//                         ? dayjs(row.OutTime, "hh:mm A").format("HH:mm")
//                         : ""}
//                     </StyledTableCell>
//                     <StyledTableCell
//                       align="center"
//                       sx={{ borderRight: "1px solid #ddd" }}
//                     >
//                       {row.VIn && dayjs(row.VIn, ["hh:mm A", "HH:mm"]).isValid()
//                         ? dayjs(row.VIn, ["hh:mm A", "HH:mm"]).format("HH:mm")
//                         : ""}
//                     </StyledTableCell>
//                     <StyledTableCell
//                       align="center"
//                       sx={{ borderRight: "1px solid #ddd" }}
//                     >
//                       {row.VOut &&
//                       dayjs(row.VOut, ["hh:mm A", "HH:mm"]).isValid()
//                         ? dayjs(row.VOut, ["hh:mm A", "HH:mm"]).format("HH:mm")
//                         : ""}
//                     </StyledTableCell>
//                   </>
//                 )}
//               </StyledTableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     );
//   }, [responseBody]);

//   return loading ? (
//     <Loader />
//   ) : (
//     <Box sx={{ width: "100%" }}>
//       {responseBody.length > 0 ? mappedItems : <NotFound text={msg} />}
//     </Box>
//   );
// }



import React, { useState, useMemo, useEffect } from "react";
import { useSelector } from "react-redux";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";

import { Alert, Box, Typography, IconButton, Tooltip } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import EditNoteIcon from "@mui/icons-material/EditNote";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import Loader from "../Utility/Loader";
import NotFound from "../Utility/NotFound";
import ManualAttendanceDialog from "./ManualAttendanceDialog";
import AttendanceService from "../../service/AttendanceService";

dayjs.extend(customParseFormat);

const GRACE_COLOR = "#FFD699";
const LATE_COLOR = "#EB895B";
const LEAVE_COLOR = "#4fee4f";

const HOLIDAY_TYPES = {
  PD: { label: "Poya", color: "#f3970c" },
  MD: { label: "Mercantile", color: "#f30c0c" },
  CD: { label: "Common Holiday", color: "#B0C4DE" },
  default: { label: "Holiday", color: "#f30c0c" },
};

const getHolidayMeta = (type) =>
  HOLIDAY_TYPES[type] || HOLIDAY_TYPES.default;

const getDateKey = (value) => {
  if (!value) return null;

  const parsed = dayjs(
    value,
    [
      "M/D/YYYY h:mm:ss A",
      "MM/DD/YYYY hh:mm:ss A",
      "M/D/YYYY",
      "YYYY-MM-DD",
    ],
    true
  );

  if (parsed.isValid()) return parsed.format("YYYY-MM-DD");

  const fallback = dayjs(value);
  return fallback.isValid() ? fallback.format("YYYY-MM-DD") : null;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&.MuiTableCell-head": {
    backgroundColor: "#1976d2",
    color: theme.palette.common.white,
    fontSize: 12,
    fontWeight: 600,
    padding: "4px",
    height: "30px",
    lineHeight: "1",
    borderRight: "1px solid #ddd",
  },
  "&.MuiTableCell-body": {
    fontSize: 12,
    color: "black",
    padding: "2px 4px",
    lineHeight: "1",
    borderRight: "1px solid #ddd",
  },
}));

const StyledTableRow = styled(TableRow)(({ bgcolor }) => ({
  backgroundColor: bgcolor || "inherit",
  "& td, & th": {
    backgroundColor: "inherit",
    textAlign: "center",
    padding: "2px 4px",
    height: "30px",
    borderBottom: "1px solid #ddd",
  },
}));

// Parse attendance time using supported formats.
const parseAttendanceTime = (time) => {
  if (!time) return null;

  const parsed = dayjs(
    time,
    ["hh:mm A", "h:mm A", "HH:mm", "H:mm"],
    true
  );

  return parsed.isValid() ? parsed : null;
};

// Convert time to minutes after midnight for reliable comparisons.
const getMinutes = (time) => {
  if (!time) return null;

  return time.hour() * 60 + time.minute();
};

export default function AttendanceCard({ onRefresh, selectedYear }) {
  const { responseBody, loading, msg } = useSelector(
    (state) => state.attendanceCard
  );
  const [holidaysByDate, setHolidaysByDate] = useState({});
  const [holidayError, setHolidayError] = useState(null);

  useEffect(() => {
    let isCurrent = true;

    const fetchHolidays = async () => {
      setHolidaysByDate({});
      setHolidayError(null);

      try {
        const response = await AttendanceService.GetDGESCalendar(selectedYear);
        const holidayList = response.data?.ResultSet;

        if (
          response.data?.StatusCode !== 200 ||
          (holidayList != null && !Array.isArray(holidayList))
        ) {
          throw new Error("Invalid holiday calendar response.");
        }

        const holidays = {};
        (holidayList || []).forEach((holiday) => {
          const key = getDateKey(holiday.date);
          if (key) holidays[key] = holiday;
        });

        if (isCurrent) setHolidaysByDate(holidays);
      } catch {
        if (isCurrent) {
          setHolidayError("Could not load calendar holidays. Please try again.");
        }
      }
    };

    if (selectedYear) fetchHolidays();

    return () => {
      isCurrent = false;
    };
  }, [selectedYear]);

  const [dialogState, setDialogState] = useState({
    open: false,
    rowData: null,
  });

  const handleOpenDialog = (row) => {
    setDialogState({
      open: true,
      rowData: row,
    });
  };

  const handleCloseDialog = () => {
    setDialogState({
      open: false,
      rowData: null,
    });
  };

  const handleSuccess = () => {
    if (onRefresh) {
      onRefresh();
    }
  };

  const mappedItems = useMemo(() => {
    return (
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          overflowX: "auto",
        }}
      >
        <Table
          sx={{ width: "100%" }}
          aria-label="attendance table"
        >
          <TableHead>
            <TableRow>
              <StyledTableCell
                align="center"
                rowSpan={2}
                sx={{
                  width: "15%",
                  borderRight: "1px solid #ddd",
                }}
              >
                Day
              </StyledTableCell>

              <StyledTableCell
                align="center"
                colSpan={3}
                sx={{ borderRight: "1px solid #ddd" }}
              >
                Attendance
              </StyledTableCell>

              <StyledTableCell
                align="center"
                colSpan={2}
                sx={{ borderRight: "1px solid #ddd" }}
              >
                Vehicle
              </StyledTableCell>

              <StyledTableCell
                align="center"
                rowSpan={2}
                sx={{ width: "10%" }}
              >
                Adj
              </StyledTableCell>
            </TableRow>

            <TableRow>
              <StyledTableCell
                align="center"
                sx={{
                  width: "14%",
                  borderRight: "1px solid #ddd",
                }}
              >
                IN
              </StyledTableCell>

              <StyledTableCell
                align="center"
                sx={{
                  width: "5%",
                  borderRight: "1px solid #ddd",
                }}
              >
                C
              </StyledTableCell>

              <StyledTableCell
                align="center"
                sx={{
                  width: "14%",
                  borderRight: "1px solid #ddd",
                }}
              >
                OUT
              </StyledTableCell>

              <StyledTableCell
                align="center"
                sx={{
                  width: "14%",
                  borderRight: "1px solid #ddd",
                }}
              >
                IN
              </StyledTableCell>

              <StyledTableCell
                align="center"
                sx={{
                  width: "14%",
                  borderRight: "1px solid #ddd",
                }}
              >
                OUT
              </StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {(responseBody || []).map((row, index) => {
              const rowDate = new Date(row.Date);
              const holiday = holidaysByDate[getDateKey(row.Date)];
              const holidayMeta = holiday
                ? getHolidayMeta(holiday.holType)
                : null;

              const today = new Date();
              today.setHours(0, 0, 0, 0);

              const normalizedRowDate = new Date(row.Date);
              normalizedRowDate.setHours(0, 0, 0, 0);

              const isSunday = rowDate.getDay() === 0;
              const isFutureDate = normalizedRowDate > today;
              const hasLeave = [row.LeaveType, row.LeaveReason].some(
                (value) => value != null && String(value).trim() !== ""
              );

              const isNoAttendance =
                !row.InTime &&
                !row.OutTime &&
                !isSunday &&
                !isFutureDate &&
                !holiday &&
                !hasLeave;
              const isStatusRow =
                hasLeave ||
                isNoAttendance ||
                (holiday && !row.InTime && !row.OutTime);
              const statusLabel = [
                holiday?.holDes,
                hasLeave
                  ? row.LeaveReason || row.LeaveType || "Leave"
                  : null,
                isNoAttendance ? "Leave" : null,
              ]
                .filter(Boolean)
                .join(" · ");
              const rowBackgroundColor = hasLeave
                ? LEAVE_COLOR
                : isNoAttendance
                ? LEAVE_COLOR
                : holidayMeta
                ? alpha(holidayMeta.color, 0.16)
                : row.BackgroundColor;

              // Grace: 08:00 AM - 08:05 AM
              // Late:  08:06 AM - 08:15 AM inclusive
              const parsedInTime = parseAttendanceTime(row.InTime);
              const inMinutes = getMinutes(parsedInTime);

              const graceStart = 8 * 60 + 1;
              const graceEnd = 8 * 60 + 5;

              const lateStart = 8 * 60 + 6;
              const lateEnd = 8 * 60 + 15;

              const isGrace =
                inMinutes !== null &&
                inMinutes >= graceStart &&
                inMinutes <= graceEnd;

              const isLate =
                inMinutes !== null &&
                inMinutes >= lateStart &&
                inMinutes <= lateEnd;

              const inTimeColor = isGrace
                ? GRACE_COLOR
                : isLate
                ? LATE_COLOR
                : "inherit";

              return (
                <StyledTableRow
                  key={index}
                  bgcolor={rowBackgroundColor}
                >
                  {/* Day */}
                  <StyledTableCell
                    component="th"
                    scope="row"
                    align="center"
                    sx={{ borderRight: "1px solid #ddd" }}
                  >
                    <Tooltip title={holiday?.holDes || ""} arrow>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "column",
                          justifyContent: "center",
                          backgroundColor: holidayMeta
                            ? alpha(holidayMeta.color, 0.16)
                            : "#B5E8FF",
                          border: holidayMeta
                            ? `1px solid ${alpha(holidayMeta.color, 0.5)}`
                            : "1px solid transparent",
                          padding: "4px",
                          borderRadius: 2,
                          width: "100%",
                          height: "30px",
                        }}
                      >
                        <Typography
                          fontSize={12}
                          fontWeight={600}
                          sx={{
                            color: holidayMeta?.color || "black",
                            lineHeight: "1",
                          }}
                        >
                          {rowDate.getDate()}
                        </Typography>

                        <Typography
                          fontSize={9}
                          fontWeight={600}
                          sx={{
                            color: holidayMeta?.color || "black",
                            lineHeight: "1",
                          }}
                        >
                          {row.Day?.toString().substring(0, 3)}
                        </Typography>
                      </Box>
                    </Tooltip>
                  </StyledTableCell>

                  {/* Leave / Missing attendance */}
                  {isStatusRow ? (
                    <StyledTableCell
                      align="center"
                      colSpan={5}
                      sx={{
                        fontWeight: "bold",
                        fontSize: "14px",
                        color: "black",
                        borderRight: "1px solid #ddd",
                      }}
                    >
                      {statusLabel}
                    </StyledTableCell>
                  ) : (
                    <>
                      {/* Attendance IN */}
                      <Tooltip
                        title={
                          isGrace
                            ? "Grace Period (08:01 - 08:05)"
                            : isLate
                            ? "Late (08:06 - 08:15)"
                            : ""
                        }
                        placement="top"
                        arrow
                      >
                        <StyledTableCell
                          align="center"
                          sx={{
                            borderRight: "1px solid #ddd",
                            backgroundColor: `${inTimeColor} !important`,
                            fontWeight:
                              isLate || isGrace ? 700 : "inherit",
                            color:
                              isLate || isGrace
                                ? "#222"
                                : "inherit",
                          }}
                        >
                          {parsedInTime
                            ? parsedInTime.format("HH:mm")
                            : ""}
                        </StyledTableCell>
                      </Tooltip>

                      {/* Continued Status */}
                      <StyledTableCell
                        align="center"
                        sx={{ borderRight: "1px solid #ddd" }}
                      >
                        {row.ContinuedStatus === "Y" ? (
                          <Checkbox checked disabled />
                        ) : (
                          ""
                        )}
                      </StyledTableCell>

                      {/* Attendance OUT */}
                      <StyledTableCell
                        align="center"
                        sx={{ borderRight: "1px solid #ddd" }}
                      >
                        {parseAttendanceTime(row.OutTime)
                          ? parseAttendanceTime(
                              row.OutTime
                            ).format("HH:mm")
                          : ""}
                      </StyledTableCell>

                      {/* Vehicle IN */}
                      <StyledTableCell
                        align="center"
                        sx={{ borderRight: "1px solid #ddd" }}
                      >
                        {parseAttendanceTime(row.VIn)
                          ? parseAttendanceTime(
                              row.VIn
                            ).format("HH:mm")
                          : ""}
                      </StyledTableCell>

                      {/* Vehicle OUT */}
                      <StyledTableCell
                        align="center"
                        sx={{ borderRight: "1px solid #ddd" }}
                      >
                        {parseAttendanceTime(row.VOut)
                          ? parseAttendanceTime(
                              row.VOut
                            ).format("HH:mm")
                          : ""}
                      </StyledTableCell>
                    </>
                  )}

                  {/* Manual Attendance Adjustment */}
                  <StyledTableCell align="center">
                    {!isFutureDate && (
                      <Tooltip title="Manual Attendance Request">
                        <IconButton
                          size="small"
                          onClick={() => handleOpenDialog(row)}
                          sx={{
                            color: "#1976d2",
                            padding: "2px",
                          }}
                        >
                          <EditNoteIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }, [responseBody, holidaysByDate]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Box sx={{ width: "100%" }}>
          {holidayError && (
            <Alert severity="error" sx={{ mb: 1 }}>
              {holidayError}
            </Alert>
          )}

          {/* Attendance Color Legend */}
          {responseBody?.length > 0 && (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1.5,
                mb: 1,
                px: 0.5,
              }}
            >
              {[
                {
                  color: LEAVE_COLOR,
                  label: "Leave",
                  textColor: "#222",
                },
                {
                  color: GRACE_COLOR,
                  label: "Grace Period (08:01 - 08:05)",
                  textColor: "#222",
                },
                {
                  color: LATE_COLOR,
                  label: "Late (08:06 - 08:15)",
                  textColor: "#222",
                },
              ].map(({ color, label, textColor }) => (
                <Box
                  key={label}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.6,
                  }}
                >
                  <Box
                    sx={{
                      width: 14,
                      height: 14,
                      borderRadius: "3px",
                      backgroundColor: color,
                      border: "1px solid #bbb",
                      flexShrink: 0,
                    }}
                  />

                  <Typography
                    sx={{
                      fontSize: 11,
                      color: textColor,
                      fontWeight: 600,
                      lineHeight: 1,
                    }}
                  >
                    {label}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}

          {responseBody?.length > 0 ? (
            mappedItems
          ) : (
            <NotFound text={msg} />
          )}
        </Box>
      )}

      <ManualAttendanceDialog
        open={dialogState.open}
        rowData={dialogState.rowData}
        onClose={handleCloseDialog}
        onSuccess={handleSuccess}
      />
    </>
  );
}
